import { render, staticRenderFns } from "./SearchScopeRow.vue?vue&type=template&id=4905f90c&lang=pug"
import script from "./SearchScopeRow.vue?vue&type=script&lang=js"
export * from "./SearchScopeRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports